import React, { useState } from "react";
import { AiOutlineClose, AiOutlineMenu } from 'react-icons/ai'
import Logo from "../assets/logo.png"

const Navbar = () => {
    const [nav, setNav] = useState(false)

    const handleNav = () => {
        setNav(!nav)
    }
    return (
        <div className="bg-gray-100 h-32 max-w-full z-50">
            <div className="flex justify-between items-center px-4 font-bold text-gray-500 max-w-[1280px] mx-auto">
                <a href='/' className="logo mt-1 drop-shadow-2sm cursor-pointer">
                    <img src={Logo} alt="Logo Kayrakkum" />
                </a>

                <ul className="hidden md:flex">
                    <li className="p-4">
                        <a href='/'>
                            Кайраккум
                        </a>
                    </li>
                    <li className="p-4">
                        <a href="/gallery">Фотогалерея</a>
                    </li>
                    <li className="p-4">
                        <a href="/videos">Видео</a>
                    </li>
                    <li className="p-4">
                        <a href="/contact">Контакт</a>
                    </li>
                </ul>
                <div onClick={handleNav} className="block md:hidden">
                    {!nav ? <AiOutlineMenu size={20} /> : <AiOutlineClose size={20} />}
                </div>
                <div className={!nav ? 'fixed left-[-100%]' : 'fixed z-50 left-0 top-0 w-[60%] border-r border-r-gray-300 bg-gray-100 ease-in-out duration-500 md:hidden'}>


                    <ul className="uppercase p-2">
                        <li className="px-0 border-b border-gray-300">
                            <a className='p-4 block w-full h-full' href='/' >
                                Кайраккум
                            </a>
                        </li>
                        <li className="px-0 border-b border-gray-300">
                            <a className='p-4 block w-full h-full' href='/gallery' >
                                Фотогалерея
                            </a>
                        </li>
                        <li className="px-0 border-b border-gray-300">
                            <a className='p-4 block w-full h-full' href='/videos'>
                                Видео
                            </a>
                        </li>
                        <li className="px-0 border-b border-gray-300">
                            <a className='p-4 block w-full h-full' href='/contact' >
                                Контакт
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}
export default Navbar;